var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"gotohome"}},[_c('a',{attrs:{"href":"#","onclick":"javascript:window.history.back(-1);return false;"}},[_c('svg',{staticClass:"bi",attrs:{"width":"32","height":"32","fill":"currentColor"}},[_c('use',{attrs:{"xlink:href":_vm.home_icon_path}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }